module.exports = __webpack_public_path__ + "img/four2Orange.7de817c5.jpg";